<div class="signup-fullscreen">
  <div class="visual-pane" aria-hidden="true">
    <!-- Decorative side: background handled in CSS for performance -->
    <div class="visual-overlay">
      <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/images-grosses/landing-collage.jpg" alt="" />
    </div>
    <!-- Language selector now inside signup-container for better accessibility -->
  </div>

  <div class="signup-container">
    <div class="lang-on-pane">
      <app-language-selector [showTitle]="false"></app-language-selector>
    </div>
    <div class="signup-card">
      <div class="signup-header">
        <a [routerLink]="getRouterLink('')">
          <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png" alt="Applisound logo" draggable="false" class="no-drag">
        </a>
        <h1>{{ 'SIGNUP.CREATE_ACCOUNT' | translate }}</h1>
        <p>{{ 'SIGNUP.SUBTITLE' | translate }}</p>
      </div>

      <form class="signup-form" [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group">
            <label for="firstName">{{ 'SIGNUP.FIRST_NAME' | translate }}</label>
            <input
              type="text"
              id="firstName"
              formControlName="firstName"
              [placeholder]="'SIGNUP.FIRST_NAME_PLACEHOLDER' | translate"
              [ngClass]="{'invalid': submitted && f['firstName'].errors}"
              >
            @if (submitted && f['firstName'].errors) {
              <div class="error-message">
                @if (f['firstName'].errors?.['required']) {
                  <span>{{ 'SIGNUP.FIRST_NAME_REQUIRED' | translate }}</span>
                }
              </div>
            }
          </div>

          <div class="form-group">
            <label for="lastName">{{ 'SIGNUP.LAST_NAME' | translate }}</label>
            <input
              type="text"
              id="lastName"
              formControlName="lastName"
              [placeholder]="'SIGNUP.LAST_NAME_PLACEHOLDER' | translate"
              [ngClass]="{'invalid': submitted && f['lastName'].errors}"
              >
            @if (submitted && f['lastName'].errors) {
              <div class="error-message">
                @if (f['lastName'].errors?.['required']) {
                  <span>{{ 'SIGNUP.LAST_NAME_REQUIRED' | translate }}</span>
                }
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label for="email">{{ 'SIGNUP.EMAIL' | translate }}</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            [placeholder]="'SIGNUP.EMAIL_PLACEHOLDER' | translate"
            [ngClass]="{'invalid': submitted && f['email'].errors}"
            >
          @if (submitted && f['email'].errors) {
            <div class="error-message">
              @if (f['email'].errors?.['required']) {
                <span>{{ 'SIGNUP.EMAIL_REQUIRED' | translate }}</span>
              }
              @if (f['email'].errors?.['email']) {
                <span>{{ 'SIGNUP.EMAIL_INVALID' | translate }}</span>
              }
            </div>
          }
        </div>

        <div class="form-row">
          <div class="form-group" style="max-width: 180px;">
            <label for="phoneCountryCode">Indicatif</label>
            <select id="phoneCountryCode" formControlName="phoneCountryCode" class="form-control">
              @for (c of countryCodes; track c) {
                <option [value]="c.code">{{ c.label }}</option>
              }
            </select>
          </div>
          <div class="form-group" style="flex: 1;">
            <label for="phone">Téléphone (optionnel)</label>
            <input
              type="tel"
              id="phone"
              formControlName="phone"
              placeholder="06 12 34 56 78"
              [ngClass]="{'invalid': submitted && f['phone'].errors}"
              />
            @if (submitted && f['phone'].errors) {
              <div class="error-message">
                @if (f['phone'].errors?.['phone']) {
                  <span>Numéro invalide</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- Extra optional details moved here right after phone -->
        <div class="extra-section">
          <div class="extra-header">
            <h2>Détails optionnels</h2>
            <button type="button" class="toggle-extra" (click)="toggleExtra()">
              {{ showExtra ? 'Ignorer pour l\'instant' : 'Renseigner maintenant' }}
            </button>
          </div>
          @if (showExtra) {
            <div class="extra-content">
              <div class="form-group">
                <label>Photo de profil (optionnel)</label>
                <div class="avatar-mode-switch">
                  <label><input type="radio" name="avatarMode" [(ngModel)]="avatarMode" [ngModelOptions]="{standalone: true}" value="upload"> Upload</label>
                  <label><input type="radio" name="avatarMode" [(ngModel)]="avatarMode" [ngModelOptions]="{standalone: true}" value="url"> Lien image</label>
                </div>
                @if (avatarMode === 'upload') {
                  <div class="avatar-upload">
                    <input type="file" accept="image/*" (change)="onAvatarFileSelected($event)" />
                  </div>
                }
                @if (avatarMode === 'url') {
                  <div class="avatar-url">
                    <input type="url" placeholder="https://exemple.com/mon-avatar.png" formControlName="avatarUrl" (input)="onAvatarUrlChange()" />
                  </div>
                }
                @if (avatarCroppedDataUrl) {
                  <div class="avatar-preview">
                    <div class="avatar-200">
                      <img [src]="avatarCroppedDataUrl" alt="avatar preview 200x200" />
                    </div>
                    <div class="crop-controls">
                      <label>Zoom
                        <input type="range" min="1" max="2" step="0.01" [(ngModel)]="cropScale" (input)="onCropParamsChange()" />
                      </label>
                      <label>Déplacer X
                        <input type="range" min="-100" max="100" step="1" [(ngModel)]="cropShiftX" (input)="onCropParamsChange()" />
                      </label>
                      <label>Déplacer Y
                        <input type="range" min="-100" max="100" step="1" [(ngModel)]="cropShiftY" (input)="onCropParamsChange()" />
                      </label>
                      <small>Sortie finale: 200x200px</small>
                    </div>
                    <div class="avatar-actions">
                      <button type="button" class="btn-danger" (click)="removeAvatar()">Supprimer la photo</button>
                    </div>
                  </div>
                }
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="company">Entreprise (optionnel)</label>
                  <input type="text" id="company" formControlName="company" />
                </div>
                <div class="form-group">
                  <label for="jobTitle">Fonction (optionnel)</label>
                  <input type="text" id="jobTitle" formControlName="jobTitle" placeholder="Marketing Manager" />
                </div>
              </div>
              <p class="hint">Vous pourrez compléter ou modifier ces informations plus tard dans votre espace profil du dashboard.</p>
            </div>
          }
        </div>

        <div class="form-group">
          <label for="password">{{ 'SIGNUP.PASSWORD' | translate }}</label>
          <div class="password-input">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              [placeholder]="'SIGNUP.PASSWORD_PLACEHOLDER' | translate"
              [ngClass]="{'invalid': submitted && f['password'].errors}"
              >
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
              <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          @if (submitted && f['password'].errors) {
            <div class="error-message">
              @if (f['password'].errors?.['required']) {
                <span>{{ 'SIGNUP.PASSWORD_REQUIRED' | translate }}</span>
              }
              @if (f['password'].errors?.['minlength']) {
                <span>{{ 'SIGNUP.PASSWORD_MIN_LENGTH' | translate }}</span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <label for="confirmPassword">{{ 'SIGNUP.CONFIRM_PASSWORD' | translate }}</label>
          <div class="password-input">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              [placeholder]="'SIGNUP.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
              [ngClass]="{'invalid': submitted && f['confirmPassword'].errors}"
              >
            <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
              <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          @if (submitted && f['confirmPassword'].errors) {
            <div class="error-message">
              @if (f['confirmPassword'].errors?.['required']) {
                <span>{{ 'SIGNUP.CONFIRM_PASSWORD_REQUIRED' | translate }}</span>
              }
              @if (f['confirmPassword'].errors?.['matching']) {
                <span>{{ 'SIGNUP.PASSWORDS_MUST_MATCH' | translate }}</span>
              }
            </div>
          }
        </div>

        <div class="terms-privacy">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="acceptTerms">
            <span class="checkmark"></span>
            <span [innerHTML]="'SIGNUP.ACCEPT_TERMS' | translate"></span>
          </label>
          @if (submitted && f['acceptTerms'].errors) {
            <div class="error-message">
              @if (f['acceptTerms'].errors?.['required']) {
                <span>{{ 'SIGNUP.ACCEPT_TERMS_REQUIRED' | translate }}</span>
              }
            </div>
          }
        </div>

        <button type="submit" class="btn-signup-submit" [disabled]="loading">
          @if (!loading) {
            <span>{{ 'SIGNUP.CREATE_ACCOUNT_BUTTON' | translate }}</span>
          }
          @if (loading) {
            <span class="spinner"></span>
          }
        </button>

        <div class="signup-divider">
          <span>{{ 'SIGNUP.OR' | translate }}</span>
        </div>

        <div class="social-signup">
          <button type="button" class="btn-social google">
            <i class="fab fa-google"></i> Google
          </button>
          <button type="button" class="btn-social facebook">
            <i class="fab fa-facebook-f"></i> Facebook
          </button>
        </div>
      </form>

      <div class="login-prompt">
        <p>{{ 'SIGNUP.ALREADY_HAVE_ACCOUNT' | translate }} <a [routerLink]="getRouterLink('login')">{{ 'SIGNUP.SIGN_IN' | translate }}</a></p>
      </div>
    </div>
  </div>
</div>

<!-- Mobile-only selector (visual pane hidden on mobile) -->
<div class="lang-mobile light">
  <app-language-selector [showTitle]="false"></app-language-selector>
</div>

